"use client";

import Image from "next/image";
import React from "react";
import ChooseUsItem from "./ChooseUsItem";
import FadeInUp from "@/components/common/ScrollReveal";
import FadeInRight from "@/components/common/ScrollReveal";
import FadeInLeft from "@/components/common/ScrollReveal";

export default function OurCompany() {
  const chooseUsData = [
    {
      icon: "/images/experience-pitch.svg",
      title: "Experience",
      description:
        "Over two decades of industry expertise, establishing us as a trusted leader in the building materials sector.",
    },
    {
      icon: "/images/global-reach.svg",
      title: "Global Reach",
      description:
        "Supply chain operations spanning the GCC, ensuring availability and accessibility for your construction needs.",
    },
    {
      icon: "/images/comprehensive-services.svg",
      title: "Comprehensive Services",
      description:
        "From expert advice to seamless execution, we handle every aspect of your project under one roof.",
    },
    {
      icon: "/images/reliability.svg",
      title: "Reliability",
      description:
        "A proven track record of satisfied clients and successful projects across diverse sectors.",
    },
    {
      icon: "/images/extensive-product-range.svg",
      title: "Extensive Product Range",
      description:
        "A vast selection of high-quality building materials, including leading brands like Knauf, Gyproc, and Weber, to meet every project requirement.",
    },
    {
      icon: "/images/transparent-pricing.svg",
      title: "Transparent Pricing",
      description:
        "Clear and competitive pricing with no hidden costs, ensuring you get the best value for your investment.",
    },
    {
      icon: "/images/reliable-supply-chain.svg",
      title: "Reliable Supply Chain",
      description:
        "Serving as the backbone of your construction projects with consistent and timely material deliveries, supporting your success.",
    },
    {
      icon: "/images/budget-friendly-options.svg",
      title: "Budget-Friendly Options",
      description:
        "Solutions tailored to fit every budget, from premium materials for high-end projects to cost-effective options for budget-conscious builds.",
    },
  ];

  return (
    <>
      {/* Our Company Title*/}
      <div className="absolute top-0 left-0 w-[27.74vw] hidden sm:block">
        <Image
          src="/images/about-us-decor-left.svg"
          alt="About us"
          fill
          className="!static w-full"
        />
      </div>
      <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-[200vw] sm:w-[64.86vw]">
        <Image
          src="/images/about-us-decor-center.svg"
          alt="About us"
          fill
          className="!static w-full"
        />
      </div>
      <div className="absolute top-0 right-0 w-[27.74vw] hidden sm:block">
        <Image
          src="/images/about-us-decor-right.svg"
          alt="About us"
          fill
          className="!static w-full"
        />
      </div>
      <div className="max-w-[90.69vw] sm:max-w-[90.80vw] lg:max-w-[76.041vw] mx-auto relative text-center">
        <h2 className="text-mob-40 sm:text-tab-40 lg:text-web-50 font-normal leading-[120%] capitalize text-PrimaryLightBlue mb-mob-23 sm:mb-tab-23 lg:mb-web-30">
          Our Company
        </h2>
        <p className="text-center sm:w-[80%] lg:w-[51%] text-mob-20 sm:text-tab-20 lg:text-web-28 mx-auto text-ParaLight">
          <b className="font-medium block">Gemini Building Materials</b>
          is your trusted partner for all construction needs across the Gulf
          Cooperation Council (GCC). With over 30 years of experience, we are a
          leading distributor of building materials, offering comprehensive
          services from supply to execution. Our commitment to quality,
          innovation, and client satisfaction sets us apart in the industry.{" "}
        </p>

        {/* Our Story & Our Mission and Values */}
        <FadeInUp effect="fadeInUp">
          <div className="max-w-[90.69vw] sm:max-w-[90.80vw] lg:max-w-[89.58vw] mx-auto flex flex-col lg:flex-row gap-mob-40 sm:gap-tab-40  lg:gap-web-60 pt-mob-80 sm:pt-tab-80 lg:pt-[9vw]">
            <div className="flex-1 flex flex-col items-center border border-PrimaryLightBlue rounded-mob-10 sm:rounded-tab-10 lg:rounded-web-10 p-mob-35 sm:p-tab-35 lg:px-web-50 lg:py-web-65 relative after:contend-[] after:absolute lg:after:w-web-22 lg:after:h-web-22 lg:after:bg-SecondaryYellow after:rounded-full after:left-1/2 after:-translate-x-1/2 after:-top-web-11 before:contend-[] before:absolute lg:before:w-web-6 lg:before:h-web-6 lg:before:bg-PrimaryLightBlue before:rounded-full before:left-1/2 before:-translate-x-1/2 before:-top-web-3 before:z-10">
              <div className="w-mob-60 sm:w-tab-60 mb-mob-24 sm:mb-tab-24 lg:w-web-100 lg:mb-web-22">
                <Image
                  src="/images/our-story.svg"
                  alt="Our story"
                  fill
                  className="!static"
                />
              </div>
              <h6 className="text-mob-28 sm:text-tab-28 lg:text-web-32 text-PrimaryLightBlue mb-mob-23 sm:mb-tab-23 lg:mb-web-20">
                Our Story{" "}
              </h6>
              <p className="text-mob-18 sm:text-tab-18 lg:text-web-24 text-ParaLight text-center leading-[135%]">
                <b className="font-medium">Gemini Building Materials</b> was
                founded in 1995 with a vision to become a premier distributor of
                building materials in the
                <b className="font-medium">
                  United Arab Emirates, Sultanate of Oman, and Kuwait.
                </b>
                Since then, we have grown to cover the entire GCC, establishing
                ourselves as a reliable name in the construction sector. Our
                journey is rooted in a commitment to trust, quality, and a deep
                understanding of our clients&apos; needs.
              </p>
            </div>
            <div className="flex-1 flex flex-col items-center border border-PrimaryLightBlue rounded-mob-10 sm:rounded-tab-10 lg:rounded-web-10 p-mob-35 sm:p-tab-35 lg:px-web-50 lg:py-web-65 relative after:contend-[] after:absolute lg:after:w-web-22 lg:after:h-web-22 lg:after:bg-SecondaryYellow after:rounded-full after:left-1/2 after:-translate-x-1/2 after:-top-web-11 before:contend-[] before:absolute lg:before:w-web-6 lg:before:h-web-6 lg:before:bg-PrimaryLightBlue before:rounded-full before:left-1/2 before:-translate-x-1/2 before:-top-web-3 before:z-10">
              <div className="w-mob-60 sm:w-tab-60 mb-mob-24 sm:mb-tab-24 lg:w-web-100 lg:mb-web-22">
                <Image
                  src="/images/our-mission-values.svg"
                  alt="Our story"
                  fill
                  className="!static"
                />
              </div>
              <h6 className="text-mob-28 sm:text-tab-28 lg:text-web-32 text-PrimaryLightBlue mb-mob-23 sm:mb-tab-23 lg:mb-web-20">
                Our Mission and Values{" "}
              </h6>
              <p className="text-mob-18 sm:text-tab-18 lg:text-web-24 text-ParaLight text-center leading-[135%]">
                <b className="font-medium block">
                  At Gemini Building Materials,
                </b>
                we believe in being more than a supplier —we strive to be your
                partner in success. Our mission is to deliver customized
                solutions that meet each project’s unique needs. We value{" "}
                <b className="font-medium">
                  excellence, innovation, and the expertise of our dedicated
                  team,
                </b>{" "}
                who are passionate about turning your vision into reality.
              </p>
            </div>
          </div>
        </FadeInUp>

        <div className="flex flex-col gap-mob-60 sm:gap-tab-80 mt-[28vw] sm:mt-[11.97vw]">
          {/* What We Do */}
          <div className="w-full max-w-[90.69vw] sm:max-w-[90.80vw] lg:max-w-[89.58vw] mx-auto flex flex-col lg:flex-row gap-mob-40 sm:gap-tab-35 lg::gap-[8.33vw]">
            <div className="w-full lg:w-[50%] relative rounded-xl overflow-hidden">
              <Image
                src="/images/what-we-do.webp"
                alt="What we do"
                fill
                className="!static"
              />
            </div>
            <div className="w-full lg:w-[50%] flex items-center">
              <FadeInRight effect="fadeInRight">
                <div className="w-full flex items-center  ">
                  <div className="flex flex-col items-center lg:items-start text-center lg:text-left lg:max-w-[31.25vw]">
                    <h5 className="mb-mob-14 sm:mb-tab-14 lg:mb-web-14 text-mob-28 leading-[120%] sm:text-tab-28 lg:text-web-28 text-PrimaryLightBlue">
                      What We Do
                    </h5>
                    <p className="mb-mob-12 sm:mb-tab-12 lg:mb-web-14 text-mob-20 sm:text-tab-20 lg:text-web-24 text-[#6D6D6D]">
                      As building material specialists, we offer a full range of
                      services to support your construction needs:
                    </p>
                    <ul className="px-mob-35 sm:pr-0 sm:pl-tab-10 text-[#6D6D6D] text-mob-20 sm:text-tab-16 lg:text-web-20 leading-[140%]  mb-mob-24 sm:mb-tab-18 lg:mb-web-16 lg:pl-web-15">
                      <li>
                        &bull; <b className="font-medium">Supply:</b>{" "}
                        High-quality building materials for all project types.
                      </li>
                      <li>
                        &bull; <b className="font-medium">Advice:</b> Expert
                        guidance on material selection.
                      </li>
                    </ul>
                    <p className="text-[#6D6D6D] text-mob-20 sm:text-tab-20 lg:text-web-20 leading-[140%]">
                      From small residential builds to large-scale turnkey
                      projects, we provide everything under one roof.
                    </p>
                    <div className="mt-mob-60 sm:mt-tab-50 lg:mt-web-40 w-[42%] sm:w-[35%] lg:w-[4.739vw]">
                      <div className="relative block lg:hidden">
                        <Image
                          src="/images/theme-double-dot.svg"
                          alt="theme color"
                          fill
                          className="!static"
                        />
                      </div>
                      <div className="relative hidden lg:block">
                        <Image
                          src="/images/theme-dot.svg"
                          alt="theme color"
                          fill
                          className="!static"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </FadeInRight>
            </div>
          </div>
          {/* our expertise */}
          <div className="w-full max-w-[90.69vw] sm:max-w-[90.80vw] lg:max-w-[89.58vw] mx-auto flex flex-col lg:flex-row gap-mob-40 sm:gap-tab-35 lg::gap-[8.33vw]">
            <div className="relative lg:order-2 rounded-xl overflow-hidden w-full lg:w-[50%]">
              <Image
                src="/images/about-our-expertise.webp"
                alt="Our expertise"
                fill
                className="!static"
              />
            </div>

            <div className="w-full lg:w-[50%] flex items-center">
              <FadeInLeft effect="fadeInLeft">
                <div className="w-full lg:order-1 flex items-center lg:justify-end ">
                  <div className="flex flex-col items-center lg:items-start text-center lg:text-left lg:max-w-[31.25vw]">
                    <h5 className="mb-mob-14 sm:mb-tab-14 lg:mb-web-14 text-mob-28 leading-[120%] sm:text-tab-26 lg:text-web-28 text-PrimaryLightBlue text-center sm:text-left">
                      Our Expertise
                    </h5>
                    <div className="text-center lg:text-left lg:max-w-[31.25vw]">
                      <p className="text-[#6D6D6D] text-mob-20 sm:text-tab-20 lg:text-web-24 leading-[140%]">
                        With over 30 years of experience, we have worked on
                        projects across various sectors, including{" "}
                        <b className="font-medium">
                          residential buildings, private homes, hotels,
                          hospitals, shopping malls, and public infrastructure
                        </b>
                        . Our collaborations with high-profile clients have
                        resulted in innovative and durable solutions.
                      </p>
                      <div className="mt-mob-60 sm:mt-tab-40 lg:mt-web-40 w-[42%] sm:w-[25%] lg:w-[4.739vw] mx-auto lg:ml-0">
                        <div className="relative block lg:hidden">
                          <Image
                            src="/images/theme-double-dot.svg"
                            alt="theme color"
                            fill
                            className="!static"
                          />
                        </div>
                        <div className="relative hidden lg:block">
                          <Image
                            src="/images/theme-dot.svg"
                            alt="theme color"
                            fill
                            className="!static"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </FadeInLeft>
            </div>
          </div>
          {/* our network */}
          <div className="w-full max-w-[90.69vw] sm:max-w-[90.80vw] lg:max-w-[89.58vw] mx-auto flex flex-col lg:flex-row gap-mob-40 sm:gap-tab-35 lg::gap-[8.33vw]">
            <div className="relative rounded-xl overflow-hidden w-full lg:w-[50%]">
              <Image
                src="/images/about-our-network.webp"
                alt="about our network"
                fill
                className="!static"
              />
            </div>
            <div className="w-full lg:w-[50%] flex items-center">
            <FadeInRight effect="fadeInRight">
              <div className="w-full flex items-center  ">
                <div className="flex flex-col items-center lg:items-start text-center lg:text-left lg:max-w-[31.25vw]">
                  <h5 className="mb-mob-14 sm:mb-tab-14 lg:mb-web-14 text-mob-28 leading-[120%] sm:text-tab-28 lg:text-web-28 text-PrimaryLightBlue">
                    Our Network
                  </h5>
                  <div className="text-center lg:text-left lg:max-w-[31.25vw]">
                    <p className="mb-mob-12 sm:mb-tab-12 lg:mb-web-14 text-mob-20 sm:text-tab-20 lg:text-web-24 text-[#6D6D6D]">
                      Our success is built on strong partnerships. We work
                      closely with:
                    </p>
                    <ul className="px-mob-24 sm:pr-0 sm:pl-tab-10 text-[#6D6D6D] text-mob-20 sm:text-tab-16 lg:text-web-20 leading-[140%]  mb-mob-24 sm:mb-tab-18 lg:mb-web-16 lg:pl-web-15">
                      <li>&bull; Architects and designers</li>
                      <li>&bull; Sub-dealers and distributors</li>
                      <li>&bull; Investors and real estate developers</li>
                      <li>&bull; Consultants and contractors</li>
                      <li>&bull; Suppliers from around the world</li>
                    </ul>
                    <p className="text-[#6D6D6D] text-mob-20 sm:text-tab-16 lg:text-web-20 leading-[140%]">
                      This extensive network allows us to source the best
                      materials and deliver comprehensive solutions, ensuring
                      the success of every project.
                    </p>
                    <div className="mt-mob-60 sm:mt-tab-40 lg:mt-web-40 w-[42%] sm:w-[25%] lg:w-[4.739vw] mx-auto lg:ml-0">
                      <div className="relative block lg:hidden">
                        <Image
                          src="/images/theme-double-dot.svg"
                          alt="theme color"
                          fill
                          className="!static"
                        />
                      </div>
                      <div className="relative hidden lg:block">
                        <Image
                          src="/images/theme-dot.svg"
                          alt="theme color"
                          fill
                          className="!static"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </FadeInRight>
            </div>
          </div>
        </div>

        <div
          className="bg-PrimaryLightBlue rounded-[10px] mt-[13.17vw] sm:mt-[33.95vw] lg:mt-[13.17vw] px-mob-30 sm:px-tab-30 lg:px-[8.07vw] pt-mob-60 sm:pt-tab-80 lg:pt-web-100 pb-mob-70 sm:pb-tab-70 lg:pb-[8.33vw]  max-w-[90.69vw] sm:max-w-[90.80vw] lg:max-w-[89.58vw] mx-auto lg:bg-none "
          style={{
            backgroundImage: 'url("/images/why-choose-us-bg.webp")',
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        >
          <div className="flex flex-col gap-5 mb-mob-30 sm:mb-tab-40 lg:mb-web-60 ">
            <h2 className="text-mob-32 sm:text-tab-36 lg:text-web-40 text-SecondaryYellow text-center uppercase">
              Why Choose Us
            </h2>
            <p className="text-mob-20 sm:text-tab-22 lg:text-web-24 text-white text-center">
              Partner with Gemini Building Materials for:
            </p>
          </div>
          <div className="flex flex-wrap justify-center gap-mob-40 sm:gap-tab-50 lg:gap-web-80">
            {chooseUsData.map((item, index) => (
              <ChooseUsItem
                key={index}
                icon={item.icon}
                title={item.title}
                description={item.description}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
